import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "appSlice",
  standalone: true
})
export class SlicePipe implements PipeTransform {
  // eslint-disable-next-line @tseslint/class-methods-use-this
  transform (value: string, start: number, end?: number): string {
    return value.slice(start, end);
  }
}
